export enum GraduationDocumentTypeClassification {
  DIPLOMA = 'DIPLOMA',
  CERTIFICATE = 'CERTIFICATE',
  CERTIFICAT = 'CERTIFICAT',
  VOCATION = 'VOCATION',
  SUPPLEMENT = 'SUPPLEMENT',
  TRANSCRIPT = 'TRANSCRIPT',
}
